// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Bootstrap v4.3.1 (https://getbootstrap.com/)
 * Copyright 2011-2019 The Bootstrap Authors
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */


/* 
 .container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
} */

/* @media (min-width: 576px) {
    .container {
        max-width: 540px;
    }
}

@media (min-width: 768px) {
    .container {
        max-width: 720px;
    }

}


@media (min-width: 992px) {
    .container {
        max-width: 960px;
    }
}

@media (min-width: 1200px) {
    .container {
        max-width: 1140px;
    }
} */



 /* @media (min-width: 576px) {
    .col-sm {
        -ms-flex-preferred-size: 0;
        flex-basis: 0;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        max-width: 100%;
    }

    .col-sm-auto {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
    }

    .col-sm-1 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 8.33333%;
        flex: 0 0 8.33333%;
        max-width: 8.33333%;
    }

    .col-sm-2 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 16.66667%;
        flex: 0 0 16.66667%;
        max-width: 16.66667%;
    }

    .col-sm-3 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
    }

    .col-sm-4 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 33.33333%;
        flex: 0 0 33.33333%;
        max-width: 33.33333%;
    }

    .col-sm-5 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 41.66667%;
        flex: 0 0 41.66667%;
        max-width: 41.66667%;
    }

    .col-sm-6 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
    }

    .col-sm-7 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 58.33333%;
        flex: 0 0 58.33333%;
        max-width: 58.33333%;
    }

    .col-sm-8 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 66.66667%;
        flex: 0 0 66.66667%;
        max-width: 66.66667%;
    }

    .col-sm-9 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 75%;
        flex: 0 0 75%;
        max-width: 75%;
    }

    .col-sm-10 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 83.33333%;
        flex: 0 0 83.33333%;
        max-width: 83.33333%;
    }

    .col-sm-11 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 91.66667%;
        flex: 0 0 91.66667%;
        max-width: 91.66667%;
    }

    .col-sm-12 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }


}

@media (min-width: 768px) {
    .col-md {
        -ms-flex-preferred-size: 0;
        flex-basis: auto;
                -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        max-width: 100%;
    }

    .col-md-auto {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
    }

    .col-md-1 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 8.33333%;
        flex: 0 0 8.33333%;
        max-width: 8.33333%;
    }

    .col-md-2 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 16.66667%;
        flex: 0 0 16.66667%;
        max-width: 16.66667%;
    }

    .col-md-3 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
    }

    .col-md-4 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 33.33333%;
        flex: 0 0 33.33333%;
        max-width: 33.33333%;
    }

    .col-md-5 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 41.66667%;
        flex: 0 0 41.66667%;
        max-width: 41.66667%;
    }

    .col-md-6 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
    }

    .col-md-7 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 58.33333%;
        flex: 0 0 58.33333%;
        max-width: 58.33333%;
    }

    .col-md-8 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 66.66667%;
        flex: 0 0 66.66667%;
        max-width: 66.66667%;
    }

    .col-md-9 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 75%;
        flex: 0 0 75%;
        max-width: 75%;
    }

    .col-md-10 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 83.33333%;
        flex: 0 0 83.33333%;
        max-width: 83.33333%;
    }

    .col-md-11 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 91.66667%;
        flex: 0 0 91.66667%;
        max-width: 91.66667%;
    }

    .col-md-12 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }


}

@media (min-width: 992px) {
    .col-lg {
        -ms-flex-preferred-size: 0;
        flex-basis: 0;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        max-width: 100%;
    }

    .col-lg-auto {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
    }

    .col-lg-1 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 8.33333%;
        flex: 0 0 8.33333%;
        max-width: 8.33333%;
    }

    .col-lg-2 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 16.66667%;
        flex: 0 0 16.66667%;
        max-width: 16.66667%;
    }

    .col-lg-3 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
    }

    .col-lg-4 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 33.33333%;
        flex: 0 0 33.33333%;
        max-width: 33.33333%;
    }

    .col-lg-5 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 41.66667%;
        flex: 0 0 41.66667%;
        max-width: 41.66667%;
    }

    .col-lg-6 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
    }

    .col-lg-7 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 58.33333%;
        flex: 0 0 58.33333%;
        max-width: 58.33333%;
    }

    .col-lg-8 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 66.66667%;
        flex: 0 0 66.66667%;
        max-width: 66.66667%;
    }

    .col-lg-9 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 75%;
        flex: 0 0 75%;
        max-width: 75%;
    }

    .col-lg-10 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 83.33333%;
        flex: 0 0 83.33333%;
        max-width: 83.33333%;
    }

    .col-lg-11 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 91.66667%;
        flex: 0 0 91.66667%;
        max-width: 91.66667%;
    }

    .col-lg-12 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }

}

@media (min-width: 1200px) {
    .col-xl {
        -ms-flex-preferred-size: 0;
        flex-basis: 0;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        max-width: 100%;
    }

    .col-xl-auto {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
    }

    .col-xl-1 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 8.33333%;
        flex: 0 0 8.33333%;
        max-width: 8.33333%;
    }

    .col-xl-2 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 16.66667%;
        flex: 0 0 16.66667%;
        max-width: 16.66667%;
    }

    .col-xl-3 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
    }

    .col-xl-4 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 33.33333%;
        flex: 0 0 33.33333%;
        max-width: 33.33333%;
    }

    .col-xl-5 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 41.66667%;
        flex: 0 0 41.66667%;
        max-width: 41.66667%;
    }

    .col-xl-6 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
    }

    .col-xl-7 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 58.33333%;
        flex: 0 0 58.33333%;
        max-width: 58.33333%;
    }

    .col-xl-8 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 66.66667%;
        flex: 0 0 66.66667%;
        max-width: 66.66667%;
    }

    .col-xl-9 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 75%;
        flex: 0 0 75%;
        max-width: 75%;
    }

    .col-xl-10 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 83.33333%;
        flex: 0 0 83.33333%;
        max-width: 83.33333%;
    }

    .col-xl-11 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 91.66667%;
        flex: 0 0 91.66667%;
        max-width: 91.66667%;
    }

    .col-xl-12 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }


}  */


.form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

/* @media (prefers-reduced-motion: reduce) {
    .form-control {
        -webkit-transition: none;
        -o-transition: none;
        transition: none;
    }
} */

.form-control::-ms-expand {
    background-color: transparent;
    border: 0;
}


select.form-control[size], select.form-control[multiple] {
    height: auto;
}

textarea.form-control {
    height: auto;
}

.form-group {
    margin-bottom: 10px;
}

.form-text {
    display: block;
    margin-top: 0.25rem;
}

.form-row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -5px;
    margin-left: -5px;
}


.invalid-feedback {
    /*display: none;*/
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
}
.alert.alert-success {
    color: #3c763d;
    background-color: #dff0d8;
    border-color: #d6e9c6;
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    border-radius: 4px;
}
.alert.alert-danger{
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    border-radius: 4px;
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb
}

.invalid-tooltip {
    position: absolute;
    top: 100%;
    z-index: 5;
    display: none;
    max-width: 100%;
    padding: 0.25rem 0.5rem;
    margin-top: .1rem;
    font-size: 0.875rem;
    line-height: 1.5;
    color: #fff;
    background-color: rgba(220, 53, 69, 0.9);
    border-radius: 0.25rem;
}


.btn {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn:hover {
    color: #212529;
    text-decoration: none;
}

.btn:focus, .btn.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn.disabled, .btn:disabled {
    opacity: 0.65;
}

a.btn.disabled,
fieldset:disabled a.btn {
    pointer-events: none;
}

.btn-primary {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}

.btn-primary:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc;
}

.btn-primary:focus, .btn-primary.focus {
    box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
}

.btn-primary.disabled, .btn-primary:disabled {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}

.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #0062cc;
    border-color: #005cbf;
}

.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-primary.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
}


.list-group {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
}


.close {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}

.close:hover {
    color: #000;
    text-decoration: none;
}

.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
    opacity: .75;
}

button.close {
    padding: 0;
    background-color: transparent;
    border: 0;
    appearance: none;
}

a.close.disabled {
    pointer-events: none;
}


.tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    font-size: 0.875rem;
    word-wrap: break-word;
    opacity: 0;
}

.tooltip.show {
    opacity: 0.9;
}

.tooltip .arrow {
    position: absolute;
    display: block;
    width: 0.8rem;
    height: 0.4rem;
}

.tooltip .arrow::before {
    position: absolute;
    content: "";
    border-color: transparent;
    border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^="top"] {
    padding: 0.4rem 0;
}

.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^="top"] .arrow {
    bottom: 0;
}

.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^="top"] .arrow::before {
    top: 0;
    border-width: 0.4rem 0.4rem 0;
    border-top-color: #000;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^="right"] {
    padding: 0 0.4rem;
}

.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^="right"] .arrow {
    left: 0;
    width: 0.4rem;
    height: 0.8rem;
}

.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^="right"] .arrow::before {
    right: 0;
    border-width: 0.4rem 0.4rem 0.4rem 0;
    border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^="bottom"] {
    padding: 0.4rem 0;
}

.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^="bottom"] .arrow {
    top: 0;
}

.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
    bottom: 0;
    border-width: 0 0.4rem 0.4rem;
    border-bottom-color: #000;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^="left"] {
    padding: 0 0.4rem;
}

.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^="left"] .arrow {
    right: 0;
    width: 0.4rem;
    height: 0.8rem;
}

.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^="left"] .arrow::before {
    left: 0;
    border-width: 0.4rem 0 0.4rem 0.4rem;
    border-left-color: #000;
}

.tooltip-inner {
    max-width: 200px;
    padding: 0.25rem 0.5rem;
    color: #fff;
    text-align: center;
    background-color: #000;
    border-radius: 0.25rem;
}


.popover .arrow::before, .popover .arrow::after {
    position: absolute;
    display: block;
    content: "";
    border-color: transparent;
    border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^="top"] {
    margin-bottom: 0.5rem;
}

.bs-popover-top > .arrow, .bs-popover-auto[x-placement^="top"] > .arrow {
    bottom: calc((0.5rem + 1px) * -1);
}

.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^="top"] > .arrow::before {
    bottom: 0;
    border-width: 0.5rem 0.5rem 0;
    border-top-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^="top"] > .arrow::after {
    bottom: 1px;
    border-width: 0.5rem 0.5rem 0;
    border-top-color: #fff;
}

.bs-popover-right, .bs-popover-auto[x-placement^="right"] {
    margin-left: 0.5rem;
}

.bs-popover-right > .arrow, .bs-popover-auto[x-placement^="right"] > .arrow {
    left: calc((0.5rem + 1px) * -1);
    width: 0.5rem;
    height: 1rem;
    margin: 0.3rem 0;
}


.clearfix::after {
    display: block;
    clear: both;
    content: "";
}


.d-flex {
    display: flex !important;
}

.d-inline-flex {
    display: inline-flex !important;
}

/* @media (min-width: 576px) {


    .d-sm-flex {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
    }

    .d-sm-inline-flex {
        display: -webkit-inline-box !important;
        display: -ms-inline-flexbox !important;
        display: inline-flex !important;
    }
}

@media (min-width: 768px) {

    .d-md-flex {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
    }

    .d-md-inline-flex {
        display: -webkit-inline-box !important;
        display: -ms-inline-flexbox !important;
        display: inline-flex !important;
    }
}

@media (min-width: 992px) {

    .d-lg-flex {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
    }

    .d-lg-inline-flex {
        display: -webkit-inline-box !important;
        display: -ms-inline-flexbox !important;
        display: inline-flex !important;
    }
}

@media (min-width: 1200px) {

    .d-xl-flex {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
    }

    .d-xl-inline-flex {
        display: -webkit-inline-box !important;
        display: -ms-inline-flexbox !important;
        display: inline-flex !important;
    }
} */


.flex-row {
    flex-direction: row !important;
}

.flex-column {
    flex-direction: column !important;
}

.flex-row-reverse {
    flex-direction: row-reverse !important;
}

.flex-column-reverse {
    flex-direction: column-reverse !important;
}

.flex-wrap {
    flex-wrap: wrap !important;
}

.flex-nowrap {
    flex-wrap: nowrap !important;
}


.justify-content-start {
    justify-content: flex-start !important;
}

.justify-content-end {
    justify-content: flex-end !important;
}

.justify-content-center {
    justify-content: center !important;
}

.justify-content-between {
    justify-content: space-between !important;
}

.justify-content-around {
    justify-content: space-around !important;
}


.text-monospace {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
    text-align: justify !important;
}

.text-wrap {
    white-space: normal !important;
}

.text-nowrap {
    white-space: nowrap !important;
}


/* .text-left {
  text-align: left !important;
} */


/* ====================================== */
/* login */
.login .box-login {
    background: #FFFFFF;
    border-radius: 16px;
    /* width: 1124px;
    height: 1024px; */
    /* width: 1000px; */
    padding: 15px 10px;
}

.login .login-title {
    /* text-align: center; */
    font-style: normal;
    font-size: 17px;
    line-height: 24px;
    color: #000000;
    margin: 10px 0;
}

.login .login-des {
    /* text-align: center; */
    font-style: normal;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
    margin: -5px 0 10px 0
}

.login .login-left {
    /* width: 679px;
    height: 976px; */
    width: 100%;
    height: 100%;
    /* background: linear-gradient(315deg, #8360C3 0%, #2EBF91 75.03%); */
    background: linear-gradient(315deg, #42A7C3 0%, #42A7C3 75.03%);
    position: relative;
    border-radius: 16px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.login .login-left img {
    width: 100%;
    height: 100%;
    border-radius: 16px;
}

.form-control-login.is-invalid {
    border-color: #dc3545 !important;
}

.form-group.feedback stong {
    color: #696F79;
}

.form-group.feedback {
    padding: 11px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    border-radius: 0;
    position: relative;
    border-width: 0 0 0 2px;
    background-color: #f2f2f2;
    border-color: #a94442;
    color: #a94442;
}

.login .form-control-login {
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 3px rgba(0, 0, 0, 0.11);
    border-radius: 6px;
    border: 1px solid #8692A6;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    transition: all 0.2s ease-in-out;
    font-size: 14px;
    height: 38px;
}

.login .form-control-login:focus, .login .form-control-login:active {
    outline: none !important;
    box-shadow: none;
    background: #FFFFFF;
    border: 0.9px solid #1565D8;
    box-shadow: 0px 4px 10px 3px rgba(0, 0, 0, 0.11);
    /* border-color: transparent; */
}

.login .checkbox-remember {
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: #696F79;
    margin-left: 10px;
}

.checkmark {
    position: absolute;
    top: 5px;
    left: 0;

}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "\\f0c8";
    font-family: "FontAwesome";
    position: absolute;
    color: #fff;
    background: #fff;
    font-size: 20px;
    margin-top: -4px;
    transition: 0.3s;
    border: 0.5px solid #040505;
    border-radius: 5px;
}

/* Show the checkmark when checked */
.checkbox-wrap input:checked ~ .checkmark:after {
    display: block;
    content: "\\f14a";
    color: rgba(0, 0, 0, 0.2);

}

.login .checkbox-remember input:checked ~ .checkmark:after {
    color: #1565D8;
}

.login .text-forgot-pass {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    text-align: right !important;


}

.login .text-forgot-pass a {
    color: #8AC43F !important;
}

.login .text-forgot-pass a:focus {
    color: #ff2f2f !important;
}

.login .text-forgot-pass a:hover {
    color: #ff2f2f !important;
}

.login .text-left {
    display: flex;
}

.login .remember-forgot {
    margin: 10px 0 10px 0;
    display: flex;
    justify-content: space-between;
}

.login .form-control-btn {
    background: #1565D8;
    border-radius: 6px;
    height: 45px;
    width: 100%;
    margin: 10px 0 10px 0;
    cursor: pointer;
}

.login .form-control-btn:hover {
    background: #0a3c96;
}

.login .login-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.login .login-bottom div:nth-child(1) span {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #696F79;
}

.login .login-right .logo-main img {
    margin-bottom: 5px;
}

.login .login-right .logo-main {
    text-align: center;
}

.login .login-right {
    margin-top: 15px;
}

.login .login-bottom div:nth-child(1) span a {
    color: #4CAF50;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
}

.login .login-bottom div:nth-child(1) span a:hover {
    color: #df31ff;
}

.login .login-bottom div:nth-child(2) {
    margin: 20px 0 20px 0;
    text-align: center;
}

.login .div-account {
    width: 90%;
}

.login .login-bottom div:nth-child(2) p {
    position: relative;
    z-index: 1;
    margin-top: 0;
    margin-bottom: 0rem;
}

.login .login-bottom div:nth-child(2) p small {
    font-style: normal;
    font-weight: 500;
    line-height: 15px;
    color: #BABABA;
    padding: 0 15px;
    display: inline-block;
}

.login .login-bottom div:nth-child(2) .account::before {
    content: "";
    border-bottom: 1px solid #e2e2e2;
    position: absolute;
    top: 49%;
    left: 0;
    right: 0;
    z-index: -1;
}

.login .login-bottom div:nth-child(2) .account > * {
    background-color: #fff;
}

.login .login-bottom .icon {
    text-align: center;
}

.login .login-bottom .icon a:nth-child(2) {
    margin: 0 20px 0 20px;
}

.login .login-bottom .text-social a {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: rgba(0, 147, 216, 0.46);
}

.login .login-bottom .text-social a:hover {
    color: rgb(6 169 245 / 90%);
}

.login .login-bottom div:nth-child(4) {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: rgba(0, 147, 216, 0.46);
}

.login .label-login {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 10px;
    color: #696F79;
}

.ftco-section {
    padding: 2em 0;
}

.login .div-slides {
    position: relative;
    height: 100%;
    padding: 0;
}

.login .dot {
    height: 15px;
    width: 15px;
    margin: 0 2px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;
    transition: background-color 0.6s ease;
}

.login .active {
    background-color: #717171;
    width: 45px;
    border-radius: 16px;
    background: #fff;
}

.login .fade {
    animation-name: fade;
    animation-duration: 1.5s;
}

.login .mySlides {
    display: none;
    height: 100%;
    padding: 30px 20px 10px 20px;
}
.login .mySlides:first-child {
    display:block;
}
.login-left .img-ab {
    position: absolute;
}
.justify-content{
    justify-content:center;
}
@keyframes fade {
    from {
        opacity: .4
    }
    to {
        opacity: 1
    }
}

.login .mySlides img {
    height: 100%;
    max-height: 580px;
}

.login .div-dot {
    text-align: center;
    position: absolute;
    bottom: 65px;
    left: 50px;
}


/* @media only screen and (max-width: 1024px) {
    .login .login-title {
        font-size: 18px;
    }

    .login .label-login {
        font-size: 14px;
    }

    .login .checkbox-remember {
        font-size: 14px;
    }

    .login .text-forgot-pass {
        font-size: 14px;
    }

    .login .login-bottom div:nth-child(1) span {
        font-size: 14px;
    }

    .login .login-bottom .text-social a {
        font-size: 14px;
    }

    .login .login-bottom div:nth-child(1) span a {
        font-size: 14px;
    }
}

@media only screen and (max-width: 767px) {
    .login-left {
        display: none;
    }

    .box-login{
        margin-top: 20px ;
    }
    .info-company {
        font-size: 14px;
        margin-top: 20px;
        margin-bottom: 20px;
    }
}

@media only screen and (max-width: 375px) {

    .login .login-title {
        font-size: 16px;

    }

    .login .label-login {
        font-size: 12px;
        margin-bottom: 10px;
    }

    .login .checkbox-remember {
        font-size: 12px;
    }

    .login .text-forgot-pass {
        font-size: 12px;
    }

    .login .login-bottom div:nth-child(1) span {
        font-size: 12px;
    }

    .login .login-bottom .text-social a {
        font-size: 12px;
    }

    .login .login-bottom div:nth-child(1) span a {
        font-size: 12px;
    }

    .login .form-control-btn {
        height: 40px;
    }
} */


.info-company{
    color: #fff;
    margin-top: 30px;
    margin-bottom: 30px;
}

/* end login */
`, "",{"version":3,"sources":["webpack://./src/css/login_style.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;;AAGF;;;;;;;GAOG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;GAwBG;;;;CAIF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAiaG;;;AAGJ;IACI,cAAc;IACd,WAAW;IACX,mCAAmC;IACnC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;IAItB,wEAAwE;AAE5E;;AAEA;;;;;;GAMG;;AAEH;IACI,6BAA6B;IAC7B,SAAS;AACb;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IAGI,aAAa;IAEb,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;;AAGA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,wCAAwC;IACxC,sBAAsB;AAC1B;;;AAGA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IAGzB,iBAAiB;IACjB,6BAA6B;IAC7B,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IAItB,qIAAqI;AAEzI;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,UAAU;IAEV,gDAAgD;AACpD;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IAEI,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAGI,gDAAgD;AACpD;;;AAGA;IAGI,aAAa;IAIb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,SAAS;IAGT,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,SAAS;IACT,kMAAkM;IAClM,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,MAAM;IACN,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,QAAQ;IACR,oCAAoC;IACpC,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,SAAS;IACT,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;AAC1B;;;AAGA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,SAAS;IACT,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;;AAGA;IACI,cAAc;IACd,WAAW;IACX,WAAW;AACf;;;AAGA;IAGI,wBAAwB;AAC5B;;AAEA;IAGI,+BAA+B;AACnC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2DG;;;AAGH;IAII,8BAA8B;AAClC;;AAEA;IAII,iCAAiC;AACrC;;AAEA;IAII,sCAAsC;AAC1C;;AAEA;IAII,yCAAyC;AAC7C;;AAEA;IAEI,0BAA0B;AAC9B;;AAEA;IAEI,4BAA4B;AAChC;;;AAGA;IAGI,sCAAsC;AAC1C;;AAEA;IAGI,oCAAoC;AACxC;;AAEA;IAGI,kCAAkC;AACtC;;AAEA;IAGI,yCAAyC;AAC7C;;AAEA;IAEI,wCAAwC;AAC5C;;;AAGA;IACI,4GAA4G;AAChH;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;;GAEG;;;AAGH,2CAA2C;AAC3C,UAAU;AACV;IACI,mBAAmB;IACnB,mBAAmB;IACnB;qBACiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI;oBACgB;IAChB,WAAW;IACX,YAAY;IACZ,qEAAqE;IACrE,+DAA+D;IAC/D,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gDAAgD;IAChD,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IAGnB,gCAAgC;IAChC,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,wBAAwB;IAExB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,gDAAgD;IAChD,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;;AAEX;;AAEA,6DAA6D;AAC7D;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAGhB,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA,oCAAoC;AACpC;IACI,cAAc;IACd,gBAAgB;IAChB,yBAAyB;;AAE7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;;AAGhC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,4BAA4B;AAChC;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgFG;;;AAGH;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,cAAc","sourcesContent":["/*!\n * Bootstrap v4.3.1 (https://getbootstrap.com/)\n * Copyright 2011-2019 The Bootstrap Authors\n * Copyright 2011-2019 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n\n\n/* \n .container {\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px;\n    margin-right: auto;\n    margin-left: auto;\n} */\n\n/* @media (min-width: 576px) {\n    .container {\n        max-width: 540px;\n    }\n}\n\n@media (min-width: 768px) {\n    .container {\n        max-width: 720px;\n    }\n\n}\n\n\n@media (min-width: 992px) {\n    .container {\n        max-width: 960px;\n    }\n}\n\n@media (min-width: 1200px) {\n    .container {\n        max-width: 1140px;\n    }\n} */\n\n\n\n /* @media (min-width: 576px) {\n    .col-sm {\n        -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n        -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n        max-width: 100%;\n    }\n\n    .col-sm-auto {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n        width: auto;\n        max-width: 100%;\n    }\n\n    .col-sm-1 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 8.33333%;\n        flex: 0 0 8.33333%;\n        max-width: 8.33333%;\n    }\n\n    .col-sm-2 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n        max-width: 16.66667%;\n    }\n\n    .col-sm-3 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n        max-width: 25%;\n    }\n\n    .col-sm-4 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n        max-width: 33.33333%;\n    }\n\n    .col-sm-5 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 41.66667%;\n        flex: 0 0 41.66667%;\n        max-width: 41.66667%;\n    }\n\n    .col-sm-6 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        max-width: 50%;\n    }\n\n    .col-sm-7 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 58.33333%;\n        flex: 0 0 58.33333%;\n        max-width: 58.33333%;\n    }\n\n    .col-sm-8 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 66.66667%;\n        flex: 0 0 66.66667%;\n        max-width: 66.66667%;\n    }\n\n    .col-sm-9 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n        max-width: 75%;\n    }\n\n    .col-sm-10 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 83.33333%;\n        flex: 0 0 83.33333%;\n        max-width: 83.33333%;\n    }\n\n    .col-sm-11 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 91.66667%;\n        flex: 0 0 91.66667%;\n        max-width: 91.66667%;\n    }\n\n    .col-sm-12 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n        max-width: 100%;\n    }\n\n\n}\n\n@media (min-width: 768px) {\n    .col-md {\n        -ms-flex-preferred-size: 0;\n        flex-basis: auto;\n                -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n        max-width: 100%;\n    }\n\n    .col-md-auto {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n        width: auto;\n        max-width: 100%;\n    }\n\n    .col-md-1 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 8.33333%;\n        flex: 0 0 8.33333%;\n        max-width: 8.33333%;\n    }\n\n    .col-md-2 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n        max-width: 16.66667%;\n    }\n\n    .col-md-3 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n        max-width: 25%;\n    }\n\n    .col-md-4 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n        max-width: 33.33333%;\n    }\n\n    .col-md-5 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 41.66667%;\n        flex: 0 0 41.66667%;\n        max-width: 41.66667%;\n    }\n\n    .col-md-6 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        max-width: 50%;\n    }\n\n    .col-md-7 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 58.33333%;\n        flex: 0 0 58.33333%;\n        max-width: 58.33333%;\n    }\n\n    .col-md-8 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 66.66667%;\n        flex: 0 0 66.66667%;\n        max-width: 66.66667%;\n    }\n\n    .col-md-9 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n        max-width: 75%;\n    }\n\n    .col-md-10 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 83.33333%;\n        flex: 0 0 83.33333%;\n        max-width: 83.33333%;\n    }\n\n    .col-md-11 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 91.66667%;\n        flex: 0 0 91.66667%;\n        max-width: 91.66667%;\n    }\n\n    .col-md-12 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n        max-width: 100%;\n    }\n\n\n}\n\n@media (min-width: 992px) {\n    .col-lg {\n        -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n        -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n        max-width: 100%;\n    }\n\n    .col-lg-auto {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n        width: auto;\n        max-width: 100%;\n    }\n\n    .col-lg-1 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 8.33333%;\n        flex: 0 0 8.33333%;\n        max-width: 8.33333%;\n    }\n\n    .col-lg-2 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n        max-width: 16.66667%;\n    }\n\n    .col-lg-3 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n        max-width: 25%;\n    }\n\n    .col-lg-4 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n        max-width: 33.33333%;\n    }\n\n    .col-lg-5 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 41.66667%;\n        flex: 0 0 41.66667%;\n        max-width: 41.66667%;\n    }\n\n    .col-lg-6 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        max-width: 50%;\n    }\n\n    .col-lg-7 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 58.33333%;\n        flex: 0 0 58.33333%;\n        max-width: 58.33333%;\n    }\n\n    .col-lg-8 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 66.66667%;\n        flex: 0 0 66.66667%;\n        max-width: 66.66667%;\n    }\n\n    .col-lg-9 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n        max-width: 75%;\n    }\n\n    .col-lg-10 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 83.33333%;\n        flex: 0 0 83.33333%;\n        max-width: 83.33333%;\n    }\n\n    .col-lg-11 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 91.66667%;\n        flex: 0 0 91.66667%;\n        max-width: 91.66667%;\n    }\n\n    .col-lg-12 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n        max-width: 100%;\n    }\n\n}\n\n@media (min-width: 1200px) {\n    .col-xl {\n        -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n        -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n        max-width: 100%;\n    }\n\n    .col-xl-auto {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n        width: auto;\n        max-width: 100%;\n    }\n\n    .col-xl-1 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 8.33333%;\n        flex: 0 0 8.33333%;\n        max-width: 8.33333%;\n    }\n\n    .col-xl-2 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n        max-width: 16.66667%;\n    }\n\n    .col-xl-3 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n        max-width: 25%;\n    }\n\n    .col-xl-4 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n        max-width: 33.33333%;\n    }\n\n    .col-xl-5 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 41.66667%;\n        flex: 0 0 41.66667%;\n        max-width: 41.66667%;\n    }\n\n    .col-xl-6 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        max-width: 50%;\n    }\n\n    .col-xl-7 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 58.33333%;\n        flex: 0 0 58.33333%;\n        max-width: 58.33333%;\n    }\n\n    .col-xl-8 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 66.66667%;\n        flex: 0 0 66.66667%;\n        max-width: 66.66667%;\n    }\n\n    .col-xl-9 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n        max-width: 75%;\n    }\n\n    .col-xl-10 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 83.33333%;\n        flex: 0 0 83.33333%;\n        max-width: 83.33333%;\n    }\n\n    .col-xl-11 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 91.66667%;\n        flex: 0 0 91.66667%;\n        max-width: 91.66667%;\n    }\n\n    .col-xl-12 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n        max-width: 100%;\n    }\n\n\n}  */\n\n\n.form-control {\n    display: block;\n    width: 100%;\n    height: calc(1.5em + 0.75rem + 2px);\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n    transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n    -o-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n}\n\n/* @media (prefers-reduced-motion: reduce) {\n    .form-control {\n        -webkit-transition: none;\n        -o-transition: none;\n        transition: none;\n    }\n} */\n\n.form-control::-ms-expand {\n    background-color: transparent;\n    border: 0;\n}\n\n\nselect.form-control[size], select.form-control[multiple] {\n    height: auto;\n}\n\ntextarea.form-control {\n    height: auto;\n}\n\n.form-group {\n    margin-bottom: 10px;\n}\n\n.form-text {\n    display: block;\n    margin-top: 0.25rem;\n}\n\n.form-row {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    margin-right: -5px;\n    margin-left: -5px;\n}\n\n\n.invalid-feedback {\n    /*display: none;*/\n    width: 100%;\n    margin-top: 0.25rem;\n    font-size: 80%;\n    color: #dc3545;\n}\n.alert.alert-success {\n    color: #3c763d;\n    background-color: #dff0d8;\n    border-color: #d6e9c6;\n    padding: 15px;\n    margin-bottom: 20px;\n    border: 1px solid transparent;\n    border-radius: 4px;\n}\n.alert.alert-danger{\n    padding: 15px;\n    margin-bottom: 20px;\n    border: 1px solid transparent;\n    border-radius: 4px;\n    color: #721c24;\n    background-color: #f8d7da;\n    border-color: #f5c6cb\n}\n\n.invalid-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%;\n    padding: 0.25rem 0.5rem;\n    margin-top: .1rem;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    color: #fff;\n    background-color: rgba(220, 53, 69, 0.9);\n    border-radius: 0.25rem;\n}\n\n\n.btn {\n    display: inline-block;\n    font-weight: 400;\n    color: #212529;\n    text-align: center;\n    vertical-align: middle;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid transparent;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    border-radius: 0.25rem;\n    -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n    -o-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n}\n\n.btn:hover {\n    color: #212529;\n    text-decoration: none;\n}\n\n.btn:focus, .btn.focus {\n    outline: 0;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.btn.disabled, .btn:disabled {\n    opacity: 0.65;\n}\n\na.btn.disabled,\nfieldset:disabled a.btn {\n    pointer-events: none;\n}\n\n.btn-primary {\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff;\n}\n\n.btn-primary:hover {\n    color: #fff;\n    background-color: #0069d9;\n    border-color: #0062cc;\n}\n\n.btn-primary:focus, .btn-primary.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n}\n\n.btn-primary.disabled, .btn-primary:disabled {\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,\n.show > .btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #0062cc;\n    border-color: #005cbf;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-primary.dropdown-toggle:focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n    box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);\n}\n\n\n.list-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n}\n\n\n.close {\n    float: right;\n    font-size: 1.5rem;\n    font-weight: 700;\n    line-height: 1;\n    color: #000;\n    text-shadow: 0 1px 0 #fff;\n    opacity: .5;\n}\n\n.close:hover {\n    color: #000;\n    text-decoration: none;\n}\n\n.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {\n    opacity: .75;\n}\n\nbutton.close {\n    padding: 0;\n    background-color: transparent;\n    border: 0;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\na.close.disabled {\n    pointer-events: none;\n}\n\n\n.tooltip {\n    position: absolute;\n    z-index: 1070;\n    display: block;\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    letter-spacing: normal;\n    word-break: normal;\n    word-spacing: normal;\n    white-space: normal;\n    line-break: auto;\n    font-size: 0.875rem;\n    word-wrap: break-word;\n    opacity: 0;\n}\n\n.tooltip.show {\n    opacity: 0.9;\n}\n\n.tooltip .arrow {\n    position: absolute;\n    display: block;\n    width: 0.8rem;\n    height: 0.4rem;\n}\n\n.tooltip .arrow::before {\n    position: absolute;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid;\n}\n\n.bs-tooltip-top, .bs-tooltip-auto[x-placement^=\"top\"] {\n    padding: 0.4rem 0;\n}\n\n.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=\"top\"] .arrow {\n    bottom: 0;\n}\n\n.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=\"top\"] .arrow::before {\n    top: 0;\n    border-width: 0.4rem 0.4rem 0;\n    border-top-color: #000;\n}\n\n.bs-tooltip-right, .bs-tooltip-auto[x-placement^=\"right\"] {\n    padding: 0 0.4rem;\n}\n\n.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=\"right\"] .arrow {\n    left: 0;\n    width: 0.4rem;\n    height: 0.8rem;\n}\n\n.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=\"right\"] .arrow::before {\n    right: 0;\n    border-width: 0.4rem 0.4rem 0.4rem 0;\n    border-right-color: #000;\n}\n\n.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=\"bottom\"] {\n    padding: 0.4rem 0;\n}\n\n.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow {\n    top: 0;\n}\n\n.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before {\n    bottom: 0;\n    border-width: 0 0.4rem 0.4rem;\n    border-bottom-color: #000;\n}\n\n.bs-tooltip-left, .bs-tooltip-auto[x-placement^=\"left\"] {\n    padding: 0 0.4rem;\n}\n\n.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=\"left\"] .arrow {\n    right: 0;\n    width: 0.4rem;\n    height: 0.8rem;\n}\n\n.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=\"left\"] .arrow::before {\n    left: 0;\n    border-width: 0.4rem 0 0.4rem 0.4rem;\n    border-left-color: #000;\n}\n\n.tooltip-inner {\n    max-width: 200px;\n    padding: 0.25rem 0.5rem;\n    color: #fff;\n    text-align: center;\n    background-color: #000;\n    border-radius: 0.25rem;\n}\n\n\n.popover .arrow::before, .popover .arrow::after {\n    position: absolute;\n    display: block;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid;\n}\n\n.bs-popover-top, .bs-popover-auto[x-placement^=\"top\"] {\n    margin-bottom: 0.5rem;\n}\n\n.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=\"top\"] > .arrow {\n    bottom: calc((0.5rem + 1px) * -1);\n}\n\n.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=\"top\"] > .arrow::before {\n    bottom: 0;\n    border-width: 0.5rem 0.5rem 0;\n    border-top-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=\"top\"] > .arrow::after {\n    bottom: 1px;\n    border-width: 0.5rem 0.5rem 0;\n    border-top-color: #fff;\n}\n\n.bs-popover-right, .bs-popover-auto[x-placement^=\"right\"] {\n    margin-left: 0.5rem;\n}\n\n.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=\"right\"] > .arrow {\n    left: calc((0.5rem + 1px) * -1);\n    width: 0.5rem;\n    height: 1rem;\n    margin: 0.3rem 0;\n}\n\n\n.clearfix::after {\n    display: block;\n    clear: both;\n    content: \"\";\n}\n\n\n.d-flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n\n.d-inline-flex {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n\n/* @media (min-width: 576px) {\n\n\n    .d-sm-flex {\n        display: -webkit-box !important;\n        display: -ms-flexbox !important;\n        display: flex !important;\n    }\n\n    .d-sm-inline-flex {\n        display: -webkit-inline-box !important;\n        display: -ms-inline-flexbox !important;\n        display: inline-flex !important;\n    }\n}\n\n@media (min-width: 768px) {\n\n    .d-md-flex {\n        display: -webkit-box !important;\n        display: -ms-flexbox !important;\n        display: flex !important;\n    }\n\n    .d-md-inline-flex {\n        display: -webkit-inline-box !important;\n        display: -ms-inline-flexbox !important;\n        display: inline-flex !important;\n    }\n}\n\n@media (min-width: 992px) {\n\n    .d-lg-flex {\n        display: -webkit-box !important;\n        display: -ms-flexbox !important;\n        display: flex !important;\n    }\n\n    .d-lg-inline-flex {\n        display: -webkit-inline-box !important;\n        display: -ms-inline-flexbox !important;\n        display: inline-flex !important;\n    }\n}\n\n@media (min-width: 1200px) {\n\n    .d-xl-flex {\n        display: -webkit-box !important;\n        display: -ms-flexbox !important;\n        display: flex !important;\n    }\n\n    .d-xl-inline-flex {\n        display: -webkit-inline-box !important;\n        display: -ms-inline-flexbox !important;\n        display: inline-flex !important;\n    }\n} */\n\n\n.flex-row {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n}\n\n.flex-column {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: column !important;\n    flex-direction: column !important;\n}\n\n.flex-row-reverse {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: reverse !important;\n    -ms-flex-direction: row-reverse !important;\n    flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: reverse !important;\n    -ms-flex-direction: column-reverse !important;\n    flex-direction: column-reverse !important;\n}\n\n.flex-wrap {\n    -ms-flex-wrap: wrap !important;\n    flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n    -ms-flex-wrap: nowrap !important;\n    flex-wrap: nowrap !important;\n}\n\n\n.justify-content-start {\n    -webkit-box-pack: start !important;\n    -ms-flex-pack: start !important;\n    justify-content: flex-start !important;\n}\n\n.justify-content-end {\n    -webkit-box-pack: end !important;\n    -ms-flex-pack: end !important;\n    justify-content: flex-end !important;\n}\n\n.justify-content-center {\n    -webkit-box-pack: center !important;\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n}\n\n.justify-content-between {\n    -webkit-box-pack: justify !important;\n    -ms-flex-pack: justify !important;\n    justify-content: space-between !important;\n}\n\n.justify-content-around {\n    -ms-flex-pack: distribute !important;\n    justify-content: space-around !important;\n}\n\n\n.text-monospace {\n    font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important;\n}\n\n.text-justify {\n    text-align: justify !important;\n}\n\n.text-wrap {\n    white-space: normal !important;\n}\n\n.text-nowrap {\n    white-space: nowrap !important;\n}\n\n\n/* .text-left {\n  text-align: left !important;\n} */\n\n\n/* ====================================== */\n/* login */\n.login .box-login {\n    background: #FFFFFF;\n    border-radius: 16px;\n    /* width: 1124px;\n    height: 1024px; */\n    /* width: 1000px; */\n    padding: 15px 10px;\n}\n\n.login .login-title {\n    /* text-align: center; */\n    font-style: normal;\n    font-size: 17px;\n    line-height: 24px;\n    color: #000000;\n    margin: 10px 0;\n}\n\n.login .login-des {\n    /* text-align: center; */\n    font-style: normal;\n    font-size: 14px;\n    line-height: 20px;\n    color: #000000;\n    margin: -5px 0 10px 0\n}\n\n.login .login-left {\n    /* width: 679px;\n    height: 976px; */\n    width: 100%;\n    height: 100%;\n    /* background: linear-gradient(315deg, #8360C3 0%, #2EBF91 75.03%); */\n    background: linear-gradient(315deg, #42A7C3 0%, #42A7C3 75.03%);\n    position: relative;\n    border-radius: 16px;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n}\n\n.login .login-left img {\n    width: 100%;\n    height: 100%;\n    border-radius: 16px;\n}\n\n.form-control-login.is-invalid {\n    border-color: #dc3545 !important;\n}\n\n.form-group.feedback stong {\n    color: #696F79;\n}\n\n.form-group.feedback {\n    padding: 11px;\n    margin-bottom: 20px;\n    border: 1px solid transparent;\n    border-radius: 0;\n    position: relative;\n    border-width: 0 0 0 2px;\n    background-color: #f2f2f2;\n    border-color: #a94442;\n    color: #a94442;\n}\n\n.login .form-control-login {\n    background: #FFFFFF;\n    box-shadow: 0px 4px 10px 3px rgba(0, 0, 0, 0.11);\n    border-radius: 6px;\n    border: 1px solid #8692A6;\n    width: 100%;\n    padding-left: 20px;\n    padding-right: 20px;\n    -webkit-transition: all 0.2s ease-in-out;\n    -o-transition: all 0.2s ease-in-out;\n    transition: all 0.2s ease-in-out;\n    font-size: 14px;\n    height: 38px;\n}\n\n.login .form-control-login:focus, .login .form-control-login:active {\n    outline: none !important;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    background: #FFFFFF;\n    border: 0.9px solid #1565D8;\n    box-shadow: 0px 4px 10px 3px rgba(0, 0, 0, 0.11);\n    /* border-color: transparent; */\n}\n\n.login .checkbox-remember {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 15px;\n    line-height: 18px;\n    color: #696F79;\n    margin-left: 10px;\n}\n\n.checkmark {\n    position: absolute;\n    top: 5px;\n    left: 0;\n\n}\n\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark:after {\n    content: \"\\f0c8\";\n    font-family: \"FontAwesome\";\n    position: absolute;\n    color: #fff;\n    background: #fff;\n    font-size: 20px;\n    margin-top: -4px;\n    -webkit-transition: 0.3s;\n    -o-transition: 0.3s;\n    transition: 0.3s;\n    border: 0.5px solid #040505;\n    border-radius: 5px;\n}\n\n/* Show the checkmark when checked */\n.checkbox-wrap input:checked ~ .checkmark:after {\n    display: block;\n    content: \"\\f14a\";\n    color: rgba(0, 0, 0, 0.2);\n\n}\n\n.login .checkbox-remember input:checked ~ .checkmark:after {\n    color: #1565D8;\n}\n\n.login .text-forgot-pass {\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 19px;\n    text-align: right !important;\n\n\n}\n\n.login .text-forgot-pass a {\n    color: #8AC43F !important;\n}\n\n.login .text-forgot-pass a:focus {\n    color: #ff2f2f !important;\n}\n\n.login .text-forgot-pass a:hover {\n    color: #ff2f2f !important;\n}\n\n.login .text-left {\n    display: flex;\n}\n\n.login .remember-forgot {\n    margin: 10px 0 10px 0;\n    display: flex;\n    justify-content: space-between;\n}\n\n.login .form-control-btn {\n    background: #1565D8;\n    border-radius: 6px;\n    height: 45px;\n    width: 100%;\n    margin: 10px 0 10px 0;\n    cursor: pointer;\n}\n\n.login .form-control-btn:hover {\n    background: #0a3c96;\n}\n\n.login .login-bottom {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.login .login-bottom div:nth-child(1) span {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    color: #696F79;\n}\n\n.login .login-right .logo-main img {\n    margin-bottom: 5px;\n}\n\n.login .login-right .logo-main {\n    text-align: center;\n}\n\n.login .login-right {\n    margin-top: 15px;\n}\n\n.login .login-bottom div:nth-child(1) span a {\n    color: #4CAF50;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 19px;\n}\n\n.login .login-bottom div:nth-child(1) span a:hover {\n    color: #df31ff;\n}\n\n.login .login-bottom div:nth-child(2) {\n    margin: 20px 0 20px 0;\n    text-align: center;\n}\n\n.login .div-account {\n    width: 90%;\n}\n\n.login .login-bottom div:nth-child(2) p {\n    position: relative;\n    z-index: 1;\n    margin-top: 0;\n    margin-bottom: 0rem;\n}\n\n.login .login-bottom div:nth-child(2) p small {\n    font-style: normal;\n    font-weight: 500;\n    line-height: 15px;\n    color: #BABABA;\n    padding: 0 15px;\n    display: inline-block;\n}\n\n.login .login-bottom div:nth-child(2) .account::before {\n    content: \"\";\n    border-bottom: 1px solid #e2e2e2;\n    position: absolute;\n    top: 49%;\n    left: 0;\n    right: 0;\n    z-index: -1;\n}\n\n.login .login-bottom div:nth-child(2) .account > * {\n    background-color: #fff;\n}\n\n.login .login-bottom .icon {\n    text-align: center;\n}\n\n.login .login-bottom .icon a:nth-child(2) {\n    margin: 0 20px 0 20px;\n}\n\n.login .login-bottom .text-social a {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    color: rgba(0, 147, 216, 0.46);\n}\n\n.login .login-bottom .text-social a:hover {\n    color: rgb(6 169 245 / 90%);\n}\n\n.login .login-bottom div:nth-child(4) {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    color: rgba(0, 147, 216, 0.46);\n}\n\n.login .label-login {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 19px;\n    margin-bottom: 10px;\n    color: #696F79;\n}\n\n.ftco-section {\n    padding: 2em 0;\n}\n\n.login .div-slides {\n    position: relative;\n    height: 100%;\n    padding: 0;\n}\n\n.login .dot {\n    height: 15px;\n    width: 15px;\n    margin: 0 2px;\n    background-color: #bbb;\n    border-radius: 50%;\n    display: inline-block;\n    cursor: pointer;\n    transition: background-color 0.6s ease;\n}\n\n.login .active {\n    background-color: #717171;\n    width: 45px;\n    border-radius: 16px;\n    background: #fff;\n}\n\n.login .fade {\n    animation-name: fade;\n    animation-duration: 1.5s;\n}\n\n.login .mySlides {\n    display: none;\n    height: 100%;\n    padding: 30px 20px 10px 20px;\n}\n.login .mySlides:first-child {\n    display:block;\n}\n.login-left .img-ab {\n    position: absolute;\n}\n.justify-content{\n    justify-content:center;\n}\n@keyframes fade {\n    from {\n        opacity: .4\n    }\n    to {\n        opacity: 1\n    }\n}\n\n.login .mySlides img {\n    height: 100%;\n    max-height: 580px;\n}\n\n.login .div-dot {\n    text-align: center;\n    position: absolute;\n    bottom: 65px;\n    left: 50px;\n}\n\n\n/* @media only screen and (max-width: 1024px) {\n    .login .login-title {\n        font-size: 18px;\n    }\n\n    .login .label-login {\n        font-size: 14px;\n    }\n\n    .login .checkbox-remember {\n        font-size: 14px;\n    }\n\n    .login .text-forgot-pass {\n        font-size: 14px;\n    }\n\n    .login .login-bottom div:nth-child(1) span {\n        font-size: 14px;\n    }\n\n    .login .login-bottom .text-social a {\n        font-size: 14px;\n    }\n\n    .login .login-bottom div:nth-child(1) span a {\n        font-size: 14px;\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .login-left {\n        display: none;\n    }\n\n    .box-login{\n        margin-top: 20px ;\n    }\n    .info-company {\n        font-size: 14px;\n        margin-top: 20px;\n        margin-bottom: 20px;\n    }\n}\n\n@media only screen and (max-width: 375px) {\n\n    .login .login-title {\n        font-size: 16px;\n\n    }\n\n    .login .label-login {\n        font-size: 12px;\n        margin-bottom: 10px;\n    }\n\n    .login .checkbox-remember {\n        font-size: 12px;\n    }\n\n    .login .text-forgot-pass {\n        font-size: 12px;\n    }\n\n    .login .login-bottom div:nth-child(1) span {\n        font-size: 12px;\n    }\n\n    .login .login-bottom .text-social a {\n        font-size: 12px;\n    }\n\n    .login .login-bottom div:nth-child(1) span a {\n        font-size: 12px;\n    }\n\n    .login .form-control-btn {\n        height: 40px;\n    }\n} */\n\n\n.info-company{\n    color: #fff;\n    margin-top: 30px;\n    margin-bottom: 30px;\n}\n\n/* end login */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
